import tw from 'tailwind-styled-components'

export const Link = tw.a`
  text-black
  hover:text-green
  hover:no-underline
  outline-none
`
